import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-qr-scanner',
  templateUrl: './modal-qr-scanner.component.html',
  styleUrls: ['./_modal-qr-scanner.component.sass'],
})
export class ModalQrScannerComponent implements OnInit, OnDestroy {
  @ViewChild('qrInput') searchElement: ElementRef;

  private tempInterval: any;

  public showModal: boolean;
  public inputCode = '';

  constructor(
    private dialogRef: MatDialogRef<ModalQrScannerComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  public ngOnInit(): void {
    this.tempInterval = this._forceFocus();
  }

  public ngOnDestroy(): void {
    clearInterval(this.tempInterval);
  }

  public enterCode() {
    this.dialogRef.close(this.inputCode);
  }

  private _forceFocus() {
    return setInterval(() => {
      if (this.searchElement) {
        this.searchElement.nativeElement.focus();
      }
    }, 500);
  }
}
